import { useState, useEffect, useCallback, useMemo } from "react";
import { apiService } from "../api/services/apiService";
import type { ProductSubscription } from "../types";
import { flattenApprovedProducts } from "../utils/subscriptionProducts";

export const useSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState<ProductSubscription[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSubscriptions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getMySubscriptions();
      setSubscriptions(data);
    } catch (err: unknown) {
      console.error(err);
      setError(err instanceof Error ? err.message : "Failed to fetch subscriptions");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSubscriptions();
  }, [fetchSubscriptions]);

  const approvedProducts = useMemo(
    () => flattenApprovedProducts(subscriptions),
    [subscriptions],
  );

  return { subscriptions, approvedProducts, loading, error, refresh: fetchSubscriptions };
};
